import React, { useState } from 'react';
import { Search, Star, Eye, Download } from 'lucide-react';
import { styles } from '../../styles/globalStyles';
import { agentLibraryStyles } from '../../styles/agentLibraryStyles';
import { agentTemplates } from '../../data/agentTemplates';
import { categories, getPriceColor } from '../../data/constants';

const AgentLibrarySection = ({ onSelectAgent }) => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  // 필터링된 에이전트들
  const filteredAgents = agentTemplates.filter(agent => {
    const matchesCategory = selectedCategory === 'All' || agent.category === selectedCategory;
    const matchesSearch = agent.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         agent.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         agent.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  return (
    <section id="agents" style={{ ...styles.section, ...agentLibraryStyles.librarySection }}>
      <div style={styles.sectionContent}>
        <h2 style={styles.sectionTitle}>
          Pre-built 
          <span style={{ background: 'linear-gradient(135deg, #7c3aed, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}> Agent Library</span>
        </h2>
        <p style={styles.sectionSubtitle}>
          Ready-to-deploy AI agents built by experts. Start with proven templates and customize for your needs.
        </p>

        {/* Search and Filter */}
        <div style={agentLibraryStyles.searchContainer}>
          <div style={agentLibraryStyles.searchBox}>
            <div style={agentLibraryStyles.searchIcon}>
              <Search size={16} />
            </div>
            <input
              type="text"
              placeholder="Search agents by name, description, or tags..."
              style={agentLibraryStyles.searchInput}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div style={agentLibraryStyles.categoryFilter}>
            {categories.map((category) => (
              <button
                key={category}
                style={{
                  ...agentLibraryStyles.categoryButton,
                  ...(selectedCategory === category ? agentLibraryStyles.categoryButtonActive : {})
                }}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Agents Grid */}
        <div style={agentLibraryStyles.agentsGrid}>
          {filteredAgents.map((agent) => (
            <div key={agent.id} style={agentLibraryStyles.agentCard}>
              <div style={agentLibraryStyles.agentHeader}>
                <div>
                  <h3 style={agentLibraryStyles.agentTitle}>{agent.name}</h3>
                  <div style={agentLibraryStyles.agentCategory}>{agent.category}</div>
                </div>
                <div style={{ ...agentLibraryStyles.agentPrice, color: getPriceColor(agent.price) }}>
                  {agent.price}
                </div>
              </div>

              <p style={agentLibraryStyles.agentDescription}>{agent.description}</p>

              <div style={agentLibraryStyles.agentTags}>
                {agent.tags.map((tag, index) => (
                  <span key={index} style={agentLibraryStyles.tag}>
                    {tag}
                  </span>
                ))}
              </div>

              <div style={agentLibraryStyles.agentStats}>
                <div style={agentLibraryStyles.rating}>
                  <Star size={12} style={{ color: '#f59e0b' }} />
                  <span>{agent.popularity}</span>
                </div>
                <div>{agent.downloads.toLocaleString()} downloads</div>
              </div>

              <div style={agentLibraryStyles.agentActions}>
                <button 
                  style={agentLibraryStyles.actionButton}
                  onClick={() => onSelectAgent(agent)}
                >
                  <Eye size={14} />
                  Preview
                </button>
                <button style={agentLibraryStyles.actionButton}>
                  <Download size={14} />
                  Deploy
                </button>
              </div>
            </div>
          ))}
        </div>

        {filteredAgents.length === 0 && (
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#9ca3af' }}>
            <h3 style={{ marginBottom: '8px' }}>No agents found</h3>
            <p>Try adjusting your search or filter criteria</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default AgentLibrarySection;